import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import { ENVELOPE_ACCESS_LINKS_QUERY_KEY } from './use-list-envelope-access-links'

const revokeEnvelopeAccessLink = async (
  envelopeId: string,
  linkId: string,
): Promise<void> => {
  await apiClient.delete(
    `/v1/ecm/envelopes/${envelopeId}/access-links/${linkId}`,
  )
}

export const useRevokeEnvelopeAccessLink = (
  envelopeId: string,
  feedback?: MutationFeedback,
) => {
  return useMutation({
    mutationFn: (linkId: string) =>
      revokeEnvelopeAccessLink(envelopeId, linkId),
    meta: { invalidatesQuery: ENVELOPE_ACCESS_LINKS_QUERY_KEY, ...feedback },
  })
}
